
export class Users {
  firstName?: string;
  lastName?: string;
  email?: string;
  nationality?: string;
  phoneNumber?: string;
  contractNumber?: string;
  cellPhoneNumber?: string;
  password?: string;
  confirmPassword?: string;
  birthday?: string
  userImage?: string
  homePhoneNumber?: string
  isActive?: boolean;
  isHaveGlasses?: boolean;
  address?: string;
  note?: string;
  userId?: string;
  gender?: number;
  creationDate?:Date
  referenceId?:string
  smsConsent?: boolean;
  smsConsentDate?: string;
  smsConsentUpdatedDate?: string;
}
export class GenratedImage {
  id: string;
  fullName: string;
  email: string;
  isActive: boolean;

}
// my-data.interface.ts

export class MidjourneyUserDetailResponse {
  items:MidjourneyUserDetail[] = [];
  total: number;
}
export class MidjourneyUserDetail {

  userId: string;
  midjourneyActionId: string;
  midjourneyContentId: string;
  contentDetails: string;
  componentsV1Custom_id: string;
  componentsV2Custom_id: string;
  componentsV3Custom_id: string;
  componentsV4Custom_id: string;
  componentsU1Custom_id: string;
  componentsU2Custom_id: string;
  componentsU3Custom_id: string;
  componentsU4Custom_id: string;
  attachmentsUrlMidjourney: string | null;
  attachmentsUrl1Midjourney: string | null;
  attachmentsUrl2Midjourney: string | null;
  attachmentsUrl3Midjourney: string | null;
  attachmentsUrl4Midjourney: string | null;
  attachmentsUrlLocal: string | null;
  attachmentsUrl1Local: string | null;
  attachmentsUrl2Local: string | null;
  attachmentsUrl3Local: string | null;
  attachmentsUrl4Local: string | null;
  attachmentsFilename: string;
  attachmentsProxy_url: string;
  id: number;
  referenceId: string;
  creationDate: string;
  langId: string | null;
  businessReferenceId: string | null;
  modifiedDate: string;
}
